<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item  prop="userId">
        <el-cascader
          :placeholder="$t('app.card.companyName')"
          ref="myCascader"
          :options="agentTree"
          :props="{ value : 'userId' , label : 'name' , checkStrictly: true,emitPath : false,multiple: true }"
          :show-all-levels="false"
          clearable
          v-model="queryParams.userIds"
          @change="search"
          filterable
        ></el-cascader>
      </el-form-item>
      <el-form-item prop="iccid">
        <el-input v-model="queryParams.iccid" :placeholder="$t('app.card.iccidPlaceholder')"  @keyup.enter.native="search" clearable ></el-input>
      </el-form-item>
      <template v-if="showSearch">
        <el-form-item  prop="imsi">
          <el-input v-model="queryParams.imsi" :placeholder="$t('app.card.imsiPlaceholder')"  @keyup.enter.native="search" clearable ></el-input>
        </el-form-item>
        <el-form-item  prop="msisdn">
          <el-input v-model="queryParams.msisdn" :placeholder="$t('app.card.msisdnPlaceholder')"  @keyup.enter.native="search" clearable ></el-input>
        </el-form-item>
        <el-form-item  prop="startIccid" v-if="adminShow">
          <el-input v-model="queryParams.startIccid" placeholder="开始号段"  @keyup.enter.native="search" clearable ></el-input>
        </el-form-item>
        <el-form-item  prop="endIccid" v-if="adminShow">
          <el-input v-model="queryParams.endIccid" placeholder="结束号段"  @keyup.enter.native="search" clearable ></el-input>
        </el-form-item>
        <el-form-item  prop="cardStatus" v-if="adminShow">
          <el-select v-model="queryParams.cardStatus" filterable placeholder="运营状态" @change="search" clearable multiple >
            <el-option value="1" label="库存"></el-option>
            <el-option value="2" label="待激活"></el-option>
            <el-option value="3" label="可测试"></el-option>
            <el-option value="4" label="已激活"></el-option>
            <el-option value="5" label="已停机"></el-option>
            <el-option value="6" label="预销户"></el-option>
            <el-option value="7" label="已销户"></el-option>
            <el-option value="8" label="停机保号"></el-option>
            <el-option value="9" label="已补卡"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item  prop="showStatus">
          <el-select v-model="queryParams.showStatus" filterable :placeholder="$t('app.card.status')" @change="search" clearable multiple>
            <el-option value="1" :label="$t('app.card.inventory')"></el-option>
            <el-option value="2" :label="$t('app.card.toBeActivated')"></el-option>
            <el-option value="3" :label="$t('app.card.testable')"></el-option>
            <el-option value="4" :label="$t('app.card.activated')"></el-option>
            <el-option value="5" :label="$t('app.card.stopped')"></el-option>
            <el-option value="6" :label="$t('app.card.preClosed')"></el-option>
            <el-option value="7" :label="$t('app.card.closed')"></el-option>
            <el-option value="8" :label="$t('app.card.paused')" v-show="adminShow"></el-option>
            <el-option value="9" :label="$t('app.card.reissued')" v-show="adminShow"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="channels" v-if="checkPermi(['card:source:show'])">
          <el-select v-model="queryParams.channels" placeholder="请选择卡源" @change="search" clearable multiple>
            <el-option
              v-for="item in channels"
              :key="item.channel"
              :label="item.name"
              :value="item.channel"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item  prop="distribution" >
          <el-select v-model="queryParams.distribution" filterable :placeholder="$t('app.card.distribution')" @change="search" clearable>
            <el-option
              v-for="item in assignData"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item  prop="remark">
          <el-input v-model="queryParams.remark" :placeholder="$t('app.card.remark')"  @keyup.enter.native="search" clearable></el-input>
        </el-form-item>
        <el-form-item  prop="cardTypeSort" v-if="adminShow">
          <el-select v-model="queryParams.cardTypeSort" multiple placeholder="请选择卡品类型" @change="search" clearable >
            <el-option value="1" label="三切"></el-option>
            <el-option value="2" label="双切"></el-option>
            <el-option value="3" label="贴片"></el-option>
            <el-option value="4" label="大卡"></el-option>
            <el-option value="5" label="eSIM卡"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item  prop="cardType" v-if="adminShow">
          <el-select v-model="queryParams.cardType" multiple placeholder="请选择卡类型" @change="search" clearable >
            <el-option
              v-for="item in cardTypeList"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>  
        </el-form-item>
        <el-form-item  prop="autoCharge" v-if="adminShow">
          <el-select v-model="queryParams.autoCharge" placeholder="是否自动充值" @change="search" clearable >
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item  prop="selectTime" v-hasPermi="['card:select:time']">
          <el-select v-model="queryParams.selectTime" filterable placeholder="时间查询方式" @change="search" clearable v-hasPermi="['card:select:time']">
            <el-option label="过期时间" value="expireTime" v-hasPermi="['card:select:time']"></el-option>
            <el-option label="关机时间" value="closeTime" v-if="adminShow"></el-option>
            <el-option label="开户时间" value="openTime" v-if="adminShow"></el-option>
            <el-option label="分配时间" value="lastAdminTransferTime" v-if="adminShow"></el-option>
            <el-option label="运营商激活时间" value="operatorActiveTime" v-if="adminShow"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item  prop="isExtraPrice" v-hasPermi="['card:select:time']">
          <el-date-picker
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            v-model="dateRange"
            @change="search"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
      </template>
      <el-form-item>
        <el-tooltip class="tooltip-button" :content="showSearch ? '隐藏搜索':'显示搜索'" placement="top">
          <el-button :icon="showSearch ? 'el-icon-arrow-up':'el-icon-arrow-down'" @click="showSearch=!showSearch"></el-button>
        </el-tooltip>
        <el-button type="primary" icon="el-icon-search"  @click="search">{{ $t('app.common.search') }}</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">{{ $t('app.common.reset') }}</el-button>
        <el-button type="primary" @click="outTable" icon="el-icon-download"  v-hasPermi="['card:export']">导出</el-button>
        <el-button type="primary" @click="packageRenewal" icon="el-icon-first-aid-kit" v-hasPermi="['card:renewal']">{{ $t('app.card.packageRenewal') }}</el-button>
        <el-dropdown @command="(command) => handleCommand(command)" style="margin-left: 10px" v-hasPermi="['card:allocation', 'card:clear','card:recycle','card:import','card:qrCode','card:setting','card:batchUpdate','card:speed','card:batchRemark']">
          <el-button type="primary">{{ $t('app.card.simConfiguration') }}<i class="el-icon-arrow-down el-icon--right"></i></el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="handleCardAllocation" icon="el-icon-star-on"
                      v-hasPermi="['card:allocation']">{{ $t('app.card.cardAllocation') }}</el-dropdown-item>
            <el-dropdown-item command="handleCardClear" icon="el-icon-brush"
                      v-hasPermi="['card:clear']">{{ $t('app.card.cardClear') }}</el-dropdown-item>
            <el-dropdown-item command="handleCardRecycle" icon="el-icon-delete"
                      v-hasPermi="['card:recycle']">{{ $t('app.card.cardRecycle') }}</el-dropdown-item>
            <el-dropdown-item command="handleCardImport" icon="el-icon-circle-plus"
                      v-hasPermi="['card:import']">{{ $t('app.card.cardImport') }}</el-dropdown-item>
            <el-dropdown-item command="handleCardQrCode" icon="el-icon-brush"
                      v-hasPermi="['card:qrCode']">{{ $t('app.card.qrCode') }}</el-dropdown-item>
            <el-dropdown-item command="handleCardSetting" icon="el-icon-s-help"
                      v-hasPermi="['card:setting']">卡操作</el-dropdown-item>
            <el-dropdown-item command="handleCardBatchUpdate" icon="el-icon-thumb"
                      v-hasPermi="['card:batchUpdate']">批量更新</el-dropdown-item>
            <el-dropdown-item command="handleCardBatchRemark" icon="el-icon-thumb"
            v-hasPermi="['card:batchRemark']">{{ $t('app.card.batchRemark') }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-form-item>
    </el-form>
      <el-table 
        :data="tableData" 
        border
        id="out-table"
        ref="tableData"
        v-loading="loading"
        @sort-change="tableSortChange"
        @selection-change="handleSelectionChange"
        :empty-text="$t('app.common.noData')"
      >
      <el-table-column type="expand" v-if="adminShow">
        <template slot-scope="props">
          <el-form label-position="left" class="table-expand">
            <el-row>
              <el-col :span="3">
                <el-form-item label="卡类型：" >
                  <span>{{ props.row.cardTypeName }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item label="卡品类型：" >
                  <span>{{ props.row.cardTypeSortName }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item label="卡要求：" >
                  <span>{{ props.row.cardRequireName }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item label="网络类型：" >
                  <span>{{ props.row.networkType }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="3">
                <el-form-item label="分配时间：" >
                  <span>{{ props.row.lastAdminTransferTime }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item label="激活时间：" >
                  <span>{{ props.row.activeTime }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item label="开户时间：" >
                  <span>{{ props.row.openTime }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item label="关机时间：" >
                  <span>{{ props.row.closeTime }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="adminShow">
              <el-col :span="3">
                <el-form-item label="MSISDN：" >
                  <span>{{ props.row.msisdn }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item label="运营商资源：" >
                  <span>{{ props.row.internationalSourceKey }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item label="当前国家：" >
                  <span>{{ props.row.country }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item label="当前运营商：" >
                  <span>{{ props.row.operatorName }}</span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column type="selection" align="center"></el-table-column>
      <el-table-column prop="ids" :label="$t('app.card.serialNumber')" align="center" width="60px"></el-table-column>
      <el-table-column prop="agentName" :label="$t('app.card.agent')" align="center" width="200px" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="iccid" label="ICCID" align="center" :sortable="adminShow ? 'custom' : false" width="200px">
        <template slot-scope="scope">
            <el-link type="primary" :underline="false" @click="info(scope.row)">{{ scope.row.iccid }}</el-link>
            <el-tooltip class="item" effect="dark" content="复制" placement="top-start">
                <i style="font-size:16px;margin-left:2px" class="el-icon-document-copy" @click="copy(scope.row.iccid)"></i>
            </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="imsi" label="IMSI" align="center" :sortable="adminShow ? 'custom' : false" width="140px"></el-table-column>
      <el-table-column prop="cardSourceName" :label="$t('app.card.cardSource')" align="center" v-if="adminShow" width="100px" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="operationName" :label="$t('app.card.operator')" align="center"></el-table-column>
      <el-table-column prop="cardStatus" :label="$t('app.card.operationStatus')" align="center" v-if="adminShow">
        <template slot-scope="{row}">
          <el-tag v-if="row.cardStatus =='已激活'">{{row.cardStatus}}</el-tag>
          <el-tag v-else-if="row.cardStatus =='库存'" type="success">{{row.cardStatus}}</el-tag>
          <el-tag v-else-if="row.cardStatus =='已停机'" type="danger">{{row.cardStatus}}</el-tag>
          <el-tag v-else-if="row.cardStatus =='待激活'" type="info">{{row.cardStatus}}</el-tag>
          <el-tag v-else type="warning">{{row.cardStatus}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="showStatus" :label="$t('app.card.status')" align="center">
        <template slot-scope="{row}">
          <el-tag v-if="row.showStatus =='已激活'">{{row.showStatus}}</el-tag>
          <el-tag v-else-if="row.showStatus =='库存'" type="success">{{row.showStatus}}</el-tag>
          <el-tag v-else-if="row.showStatus =='已停机'" type="danger">{{row.showStatus}}</el-tag>
          <el-tag v-else-if="row.showStatus =='待激活'" type="info">{{row.showStatus}}</el-tag>
          <el-tag v-else type="warning">{{row.showStatus}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="monthFlow" :label="$t('app.card.monthlyFlow')" align="center" sortable="custom" v-if="checkPermi(['card:flow'])" width="120px"></el-table-column>
      <el-table-column prop="initSpeedStatus" label="是否限速" align="center" v-if="adminShow" width="100px">
        <template slot-scope="{row}">
          <el-tag v-if="row.initSpeedStatus =='1'" type="warning">已限速</el-tag>
          <el-tag v-else >未限速</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="currentDayFlow" :label="$t('app.card.dailyUsage')" align="center" sortable="custom" v-if="adminShow" width="100px">
        <template slot-scope="{row}">
          {{mbToSize(row.currentDayFlow)}}
        </template>
      </el-table-column>
      <el-table-column prop="productMonthFlow" :label="$t('app.card.packageTotal')" align="center" sortable="custom" v-if="adminShow" width="120px"></el-table-column>
      <el-table-column prop="productUseFlow" :label="$t('app.card.packageUsed')" align="center" sortable="custom" v-if="adminShow" width="120px"></el-table-column>
      <el-table-column prop="productResidueFlow" :label="$t('app.card.packageRemaining')" align="center" sortable="custom" v-if="checkPermi(['card:flow:used'])" width="120px"></el-table-column>
      <el-table-column prop="expireTime" :label="$t('app.card.expireTime')" align="center" sortable="custom" :show-overflow-tooltip="true" width="120px"></el-table-column>
      <el-table-column prop="remark" :label="$t('app.card.remark')" align="center" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column :label="$t('app.common.operation')" align="center" width="240" fixed="right">
        <template slot-scope="scope">
          <el-button
              size="mini"
              type="primary" plain
              icon="el-icon-view"
              @click="info(scope.row)"
              v-hasPermi="['card:info']"
            >{{ $t('app.card.detail') }}</el-button>
            <el-button
              size="mini"
              type="primary" plain
              icon="el-icon-edit"
              @click="editRow(scope.row.iccid,scope.row)"
              v-hasPermi="['card:remark']"
            >{{ $t('app.card.remark') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="initData"
    />
    <el-dialog :title="title" :visible.sync="dialog" @close="dialogClose" :lock-scroll="false" width="650px" v-dialogDrag :close-on-click-modal="false">
      <el-form :model="beizhu" ref="beizhu">
        <el-form-item label="备注内容:" prop="remark" :label-width="LabelWidth">
          <el-input v-model="beizhu.remark" autocomplete="off" style="width: 80%" placeholder="请输入备注内容"></el-input>
        </el-form-item>
        <el-form-item label="售后内容:" prop="saleRemark" :label-width="LabelWidth" v-if="adminShow">
          <el-input type="textarea" v-model="beizhu.saleRemark" autocomplete="off" style="width: 80%" placeholder="请输入售后内容"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer" slot="footer">
        <el-button type="primary" @click="cancelDialog">取消</el-button>
        <el-button type="success" @click="saveDialog">确认</el-button>
      </div>
    </el-dialog>
    <!-- 卡清除 -->
    <el-dialog :title="removalTitle" :visible.sync="openRemoval" width="680px" append-to-body :close-on-click-modal="false">
      <el-form ref="removalForm" :model="removalForm" label-width="120px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="ICCID列表" prop="iccids">
              <el-input v-model="removalForm.iccids" type="textarea" clearable placeholder="请输入内容" rows="8"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="ICCID范围" >
        <el-row>
          <el-col :span="11">
            <el-form-item prop="iccidStart">
              <el-input
                v-model="removalForm.iccidStart"
                clearable
                placeholder="包含开始值"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col style="text-align: center;" :span="2">-</el-col>
          <el-col :span="11">
            <el-form-item prop="iccidEnd">
              <el-input
                v-model="removalForm.iccidEnd"
                clearable
                placeholder="包含终止值"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitRemovalForm" >确 定</el-button>
        <el-button @click="cancelRemoval">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 卡备注 -->
    <el-dialog :title="remarkTitle" :visible.sync="openRemark" width="680px" append-to-body :close-on-click-modal="false">
      <el-form ref="remarkForm" :model="remarkForm" label-width="120px">
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('app.card.cardRemark.iccidList')" prop="iccids">
              <el-input v-model="remarkForm.iccids" type="textarea" clearable :placeholder="$t('app.card.cardRemark.iccidListPlaceholder')" rows="8"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item :label="$t('app.card.cardRemark.iccidRange')" >
          <el-col :span="11">
            <el-form-item prop="startIccid">
              <el-input
                v-model="remarkForm.startIccid"
                clearable
                :placeholder="$t('app.card.cardRemark.includeStartValue')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col style="text-align: center;" :span="2">-</el-col>
          <el-col :span="11">
            <el-form-item prop="endIccid">
              <el-input
                v-model="remarkForm.endIccid"
                clearable
                :placeholder="$t('app.card.cardRemark.includeEndValue')"
              ></el-input>
            </el-form-item>
          </el-col>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('app.card.cardRemark.batchRemarkContent')" prop="remark">
              <el-input v-model="remarkForm.remark" :placeholder="$t('app.card.cardRemark.remarkPlaceholder')" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitRemarkForm" >{{ $t('app.common.confirm') }}</el-button>
        <el-button @click="cancelRemark">{{ $t('app.common.cancel') }}</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import { internationalCardList } from "@/api/international.js"; //流量卡列表
import { exportCard } from "@/api/api.js"; //流量卡导出
import { saveRemark } from "@/api/api.js"; //流量卡备注
import { cardSource } from "@/api/api.js"; //卡源
import { agentTreeList } from "@/api/api.js"; //代理商
import { cardBaseInfo } from "@/api/api.js";//卡类型
import { cardBatchSyncCard , removalCard , batchCardRemark ,listChannel} from "@/api/api.js";//批量更新
export default {
  name: "internationalCards",
  data() {
    return {
      agentUserId: this.$route.params && this.$route.params.userId,
      division:[],
      channels:[],
      loading: true,
      // 显示搜索条件
      showSearch: false,
      // 批量查询的显示
      batch:false,
      // 弹窗
      LabelWidth: "100px",
      add: true,
      dialog: false,
      title: "备注",
      beizhu:{},
      // 搜索
      dateRange:[],
      queryParams:{
        userIds:[],
        userId:undefined,
        iccid:undefined,
        imsi:undefined,
        msisdn:undefined,
        cardStatus:undefined,
        cardSourceId:undefined,
        showStatus:[],
        distribution:undefined,
        startIccid:undefined,
        endIccid:undefined,
        remark:undefined,
        phone:undefined,
        cardType:undefined,
        orientations:undefined,
        cardTypeSort:undefined,
        gprsStatus:undefined,
        cardSort:undefined,
        selectTime:undefined,
        cardMode:undefined,
        needKyc:undefined,
        cardCertType:undefined,
        internationalKey:undefined,
        channels:undefined
      },
      page: 1,
      pageSize: 20,
      total: 0,
      // 排序方式
      sortOrder: "",
      // 排序名称
      sortName: "",
      packageList:[],
      cardStatusList:[],
      cardUndistribution:false,
      
      tableData: [],
      // 代理商
      agentTree: [],
      // 来源
      source: [],
      cardTypeList:[],
      orientationList:[],
      assignData:[
        {
          value: 0,
          label: this.$t('app.card.unassigned')
        },
        {
          value: 1,
          label: this.$t('app.card.assigned') 
        },
      ],
      gprsList:[
        {
          value: '1',
          label: '已开启'
        }, {
          value: '0',
          label: '未开启'
        }
      ],
      cardSorts:[
        {
          value: '1',
          label: '测试套餐送流量'
        },
        {
          value: '2',
          label: '直接领取赠送流量'
        }
      ],
      needKycs:[
          {value:"0",label:'不需要'},
          {value:"1",label:'需要'}
      ],
      cardCertTypes:[
          {value:"1",label:'本地实名'},
          {value:"2",label:'运营商实名'}
      ],
      removalTitle:'卡清除',
      openRemoval:false,
      removalForm:{
        iccids:undefined,
        iccidStart:undefined,
        iccidEnd:undefined
      },
      openRemark:false,
      remarkTitle:this.$t('app.card.cardRemark.title'),
      remarkForm:{
        iccids:undefined,
        startIccid:undefined,
        endIccid:undefined,
        operatorType:'1',
        remark:undefined
      }
    };
  },
  computed: {
    adminShow(){
      return this.$store.getters.user.userType =='1'
    }
  },
  methods: {
    // 状态转换
    inventoryStatusType(status) {
      let obj = {
        1: "库存",
        2: "待激活",
        3: "可测试",
        4: "已激活",
        5: "已停机",
        6: "预销户",
        7: "已销户",
        8: "停机保号",
        9: "已补卡",
      };
      return obj[status];
    },
    // 多选单选的值
    handleSelectionChange(val){
      let arrlist = [];
      let cardStatusList = [];
      this.cardUndistribution = false;
      val.map(item=>{
        arrlist.push(item.iccid);
        cardStatusList.push(item.showStatus)
        if(!item.agentName){
          this.cardUndistribution = true;
        }
      })
      this.cardStatusList = cardStatusList;
      this.packageList = arrlist;
    },
    initChannel(){
      let operatorId = '4'
      if(this.checkPermi(['card:source:show'])){
        listChannel({operatorId}).then(res=>{
          this.channels = res.data.data
        })
      }
    },
    //代理商列表
    handleAgentTreeList(){
      agentTreeList().then(res => {
        this.agentTree = res.data.data;
      });
    },
    //查找卡源列表
    handleCardSource(){
      cardSource().then(res => {
        this.source = res.data.data;
      });
    },
    // 套餐续费
    packageRenewal(){
      let iccids = this.packageList;
      if(iccids.length == 0){
        //清空数据
        this.$store.dispatch('ClearProductIccids')
        this.$router.push("/order/renewal");
      }else{
        if(this.cardUndistribution){
          this.$message.error("存在未分配的卡无法充值，请重新选择！");
        }else if(this.cardStatusList.includes("已销户") || this.cardStatusList.includes("预销户")  ){
          this.$message.error("状态为已销户活预销户的卡不允许充值，请取消！");
        }else{
          this.$store.dispatch('CacheProductIccids', iccids.join(","))
          this.$router.push("/order/renewal");
        }
      }
    },
    handleOperationCard(){
      //查看选中
      let iccids = this.packageList;
      if(iccids.length == 0){
        //清空数据
        this.$store.dispatch('ClearIccids')
      }else{
        this.$store.dispatch('CacheIccids', iccids.join(","))
      }
      this.$router.push("/card/carrierStatus");
    },
    batchUpdate(){
      if(this.packageList == 0){
        return this.$message.error('请选择要更新的卡号');
      }else{
        let params = {
          iccids:this.packageList
        }
        cardBatchSyncCard(params).then(res=>{
          if (res.data.code == 200) {
            this.$notify({
              title: "成功",
              message: "批量更新",
              type: "success",
              offset:30
            });
            this.initData()
          }else{
            this.$message.error(res.data.message);
          }
        })
      }
    },
    handleCommand(command){
      switch (command) {
        case "handleCardAllocation":
          this.handleCardAllocation();
          break;
        case "handleCardClear":
          this.handleCardClear();
          break;
        case "handleCardRecycle":
          this.handleCardRecycle();
          break;
        case "handleCardImport":
          this.handleCardImport();
          break;
        case "handleCardQrCode":
          this.handleCardQrCode();
          break;
        case "handleCardSetting":
          this.handleCardSetting();
          break;
        case "handleCardBatchUpdate":
          this.handleCardBatchUpdate();
          break;
        case "handleCardBatchRemark":
          this.handleCardBatchRemark();
        break;
        default:
          break;
      }
    },
    //卡分配
    handleCardAllocation(){
      this.$router.push({name:"transfer",params:{iccids:this.packageList.toString().replaceAll(",","\n")}});
    },
    //卡清除
    handleCardClear(){
      this.openRemoval =true;
      this.removalForm.iccids = this.packageList.toString().replaceAll(",","\n")
    },
    //卡回收
    handleCardRecycle(){
      this.$router.push({name:"recovery",params:{iccids:this.packageList.toString().replaceAll(",","\n")}});
    },
    //卡导入
    handleCardImport(){
      this.$router.push("/card/import");
    },
    //二维码
    handleCardQrCode(){
      this.$router.push({name:"codeQR",params:{iccids:this.packageList.toString().replaceAll(",","\n")}});
    },
    //卡操作
    handleCardSetting(){
      this.$router.push({name:"query",params:{iccids:this.packageList.toString().replaceAll(",","\n")}});
    },
    //卡批量更新
    handleCardBatchUpdate(){
      this.batchUpdate()
    },
    handleCardBatchRemark(){
      this.openRemark =true;
      this.remarkForm.iccids = this.packageList.toString().replaceAll(",","\n")
    },
    // 排序
    tableSortChange(val){
      this.sortOrder = val.order === "descending" ? "desc" : "asc";
      if(val.prop == 'id'){
        this.sortName = 'id'
      }else if(val.prop == 'monthFlow'){
        this.sortName = 'monthFlow'
      }else if(val.prop == 'currentDayFlow'){
        this.sortName = 'currentDayFlow'
      }else if(val.prop == 'expireTime'){
        this.sortName = 'expireTime'
      }else if(val.prop == 'integral'){
        this.sortName = 'integral'
      }else if(val.prop == 'productMonthFlow'){
        this.sortName = 'productMonthFlow'
      }else if(val.prop == 'productUseFlow'){
        this.sortName = 'productUseFlow'
      }else if(val.prop == 'productResidueFlow'){
        this.sortName = 'productResidueFlow'
      }else if(val.prop == 'iccid'){
        this.sortName = 'iccid'
      }else if(val.prop == 'msisdn'){
        this.sortName = 'msisdn'
      }
      this.initData()
    },
    // 搜索
    search() {
      this.page = 1,
      this.initData();
    },
    // 重置
    resetQuery() {
      this.resetForm("queryForm");
      this.queryParams.startIccid = undefined;
      this.queryParams.endIccid = undefined;
      this.iccidShow = false;
      this.dateRange = [];
      this.sortOrder = '';
      this.sortName = '';
      this.$refs.tableData.clearSort();
      this.$refs.myCascader.$refs.panel.clearCheckedNodes();
      this.$refs.myCascader.$refs.panel.activePath = [];
      this.search();
    },
    // 导出
    outTable() {
      let params = {
        ... this.addDateRange(this.queryParams, this.dateRange),
        order: this.sortOrder,
        sort: this.sortName,
      };
      this.$alert("确定导出流量卡吗？", "流量卡导出", {
        confirmButtonText: "确定"
      }).then(() => {
        exportCard(params).then(res => {
          this.$notify({
              title: "成功",
              message: "列表导出成功，请在任务中心查看",
              type: "success",
              offset:30
            });
        });
      });
    },
    // 关闭弹窗
    dialogClose() {
      this.$refs.beizhu.clearValidate();
      this.dialog = false;
    },
    cancelDialog() {
      this.dialog = false;
    },
    // 备注
    saveDialog() {
      let params = {
        remark:this.beizhu.remark,
        iccid:this.beizhu.iccid,
        saleRemark:this.beizhu.saleRemark
      };
      saveRemark(params).then(res =>{
        if (res.data.code == 200) {
          this.$message.success("备注成功");
          this.dialog = false;
          this.beizhu = {};
          this.initData()
        }
      })
    },
    // 添加备注
    editRow(iccid,row) {
      this.beizhu = {};
      this.dialog = true;
      this.title = "备注";
      this.beizhu = Object.assign({}, row);
    },
    // 详情
    info(row) {
      this.$router.push({path:"/international/internationalDetail",query:{iccid: row.iccid}});
    },
    // 截取小数点的方法
    formatDecimal(num, decimal) {
      num = num.toString()
      let index = num.indexOf('.')
      if (index !== -1) {
          num = num.substring(0, decimal + index + 1)
      } else {
          num = num.substring(0)
      }
      return parseFloat(num).toFixed(decimal)
    },
    // 获取列表
    initData() {
      this.loading = true;
      let params = {
        model:{
					... this.addDateRange(this.queryParams, this.dateRange),
          order: this.sortOrder,
          sort: this.sortName,
				},
        page: this.page,
        pageSize: this.pageSize,
      };
      internationalCardList(params).then(res => {
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
          this.tableData.map((item,index) => {
            item.ids = index + 1;
            item.cardStatus = this.inventoryStatusType(item.cardStatus);
            item.showStatus = this.inventoryStatusType(item.showStatus);
            if(item.expireTime ){
              item.expireTime = item.expireTime.substr(0,10);
            }else{
              item.expireTime = null;
            }
            if(item.monthFlow == 0 || item.monthFlow == null){
              item.monthFlow = 0 + 'Byte'
            }else if(1024 > item.monthFlow > 0){
              item.monthFlow = this.formatDecimal(item.monthFlow,2) + "M"
            }else if(item.monthFlow >=1024){
              item.monthFlow = this.formatDecimal(item.monthFlow/1024,2) + "G"
            }
          })
          this.loading = false;
      });
    },
    batchQuery(){
      this.batch = this.batch == false ? true : false
    },
    // 卡类型数据
    cardRequirements(){
      cardBaseInfo().then(res=>{
        this.cardTypeList = res.data.data.cardType;
        this.orientationList = res.data.data.orientations;
      })
    },
    mbToSize(mb){
        const sizes = ['M', 'GB', 'TB'];
        if (mb === 0) return '0M';
        if (mb > 0 && mb<= 1 ) return mb +' M';
        const i = Math.floor(Math.log(mb) / Math.log(1024));
        return (mb / Math.pow(1024, i)).toFixed(2) + ' ' + sizes[i];
    },
    //清除卡提交
    submitRemovalForm(){
        removalCard(this.removalForm).then(res => {
            if(res.data.code ==200){
              this.$message.success("清除成功，任务中心查看进度");
              this.openRemoval = false;
              this.$refs['removalForm'].resetFields();
            }else{
              this.$message.error(res.data.message);
            }
        });
    },
    submitRemarkForm(){
      let { iccids } = this.remarkForm;
      let data = {
        ...this.remarkForm,
        operatorType:'1',
        iccids:iccids ? iccids.split("\n") : []
      };
      batchCardRemark(data).then(res => {
        this.$notify({
            title: "成功",
            message: "批量备注成功",
            type: "success"
          });
        this.$refs['remarkForm'].resetFields();
        this.openRemark = false;
        this.initData()
      });

    },
    //取消取消
    cancelRemoval(){
      this.openRemoval =false;
      this.$refs['removalForm'].resetFields();
    },
    cancelRemark(){
      this.openRemark =false;
      this.$refs['remarkForm'].resetFields();
    },
    //复制数据
    copy(data) {
        let url = data;
        let oInput = document.createElement('input');
        oInput.value = url;
        document.body.appendChild(oInput);
        oInput.select(); // 选择对象;
        document.execCommand("Copy"); // 执行浏览器复制命令
        this.$message({
            message: '复制成功',
            type: 'success',
            duration:1000
        });
        oInput.remove()
    }
  },
  watch: {
    $route: {
      handler: function(to, from){
        if(to.name == 'internationalCards'){
          let startIccid = this.$route.params && this.$route.params.startIccid;
          let endIccid = this.$route.params && this.$route.params.endIccid;
          this.queryParams.startIccid = !!startIccid ? startIccid : this.queryParams.startIccid;
          this.queryParams.endIccid = !!endIccid ? endIccid : this.queryParams.endIccid;
          this.initData();
        }
      },
      // 深度观察监听
      deep: true
    }
  },
  created() {
    let startIccid = this.$route.params && this.$route.params.startIccid;
    let endIccid = this.$route.params && this.$route.params.endIccid;
    this.queryParams.startIccid = !!startIccid ? startIccid : this.queryParams.startIccid;
    this.queryParams.endIccid = !!endIccid ? endIccid : this.queryParams.endIccid;

    this.initData();
    this.initChannel()
    this.cardRequirements();
    this.handleAgentTreeList();
  },
  mounted() {
  }
};
</script>
<style scoped lang="less">
  .table-expand{
    margin-left: 20px;
    label{
      width: 90px;
      color: #99a9bf; 
    }
    .el-form-item{
      margin-bottom: 0;
    }
  }

</style>